<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        @if (!note) {
          {{ 'components.addAppClientNote.title' | translate }}
        } @else {
          {{ 'components.addAppClientNote.titleEdit' | translate }}
        }
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="addAppClientNote" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }

    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="name">
            {{ 'components.addAppClientNote.backofficeText' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="backofficeText"
            [ngClass]="{ invalid: shouldRenderError('backofficeText') }"
            type="text"
            formControlName="backofficeText"
            name="backofficeText"
            required
            maxlength="{{ maxFieldLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: backofficeText?.value.length > maxFieldLength
            }">
            {{ backofficeText?.value.length }}/{{ maxFieldLength }}
          </p>
        </div>
        @if (getErrorMessage('backofficeText'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
      <div class="lna-row-32 value-wrapper file-list">
        <app-file-upload
          [isEditMode]="true"
          [existingFiles]="getFiles(note)"
          [type]="communicationFileType"
          [associatedEntityId]="note?.id || ''"
          [isSubmitting]="isSubmittingFiles"
          [showDescription]="true"
          (uploading)="handleFileRequests($event)" />
      </div>
      @if (shouldRenderNeedToChangeStatusButton) {
        <div class="lna-row full-width">
          <div class="checkbox-wrapper">
            <input class="form-check-input lna checkbox" id="needToProcess" type="checkbox" formControlName="needToProcess" />
            <label class="checkbox-label" [innerHTML]="'components.addAppClientNote.updateStatus' | translate" for="needToProcess"></label>
            <app-tooltip [marginBottom]="false" text="addAppClientNoteUpdateStatus" />
          </div>
        </div>
      }
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="submit()" type="button">
      @if (!note) {
        {{ 'components.addAppClientNote.save' | translate }}
      } @else {
        {{ 'components.addAppClientNote.update' | translate }}
      }
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.addAppClientNote.cancel' | translate }}
    </button>
  </div>
</ng-template>
